import { SidebarTrigger } from '@/components/ui/sidebar'
import React from 'react'
import OGEAvatar from '../OGEAvatar'

interface OGESidebarHeaderProps {
  userName: string
  avatarSrc: string
  subText?: string
  subTextAction?: React.ReactNode
  /** Set to false when rendered outside a SidebarProvider (e.g. charter pages). Defaults to true. */
  showSidebarTrigger?: boolean
}

const OGESidebarHeader: React.FC<OGESidebarHeaderProps> = ({
  userName,
  avatarSrc,
  subText,
  subTextAction,
  showSidebarTrigger = true,
}) => {
  return (
    <div className='flex h-full'>
      <div className='flex items-center w-4/5 h-full gap-3'>
        <OGEAvatar
          src={avatarSrc}
          fallback={userName.substring(0, 2).toUpperCase()}
          variant='sm'
          isLoading={false}
        />
        <div className='flex flex-col'>
          <span className='text-base font-semibold text-dark-blue'>
            {userName}
          </span>
          {subText && (
            <div className='flex items-center gap-1'>
              <span className='text-xs text-gray-500'>{subText}</span>
              {subTextAction}
            </div>
          )}
        </div>
      </div>
      {showSidebarTrigger && (
        <div className='flex items-center justify-between w-1/5 h-full text-white'>
          <img src='/icons/expand.svg' alt='' className='hidden w-4 h-5' />
          <SidebarTrigger className='group-data-[state=collapsed]:rotate-180 transition-transform duration-500 p-0 h-5 w-5 ml-7' />
        </div>
      )}
    </div>
  )
}

export default OGESidebarHeader
